import { colors, SvgIconProps, SvgIconTypeMap } from "@mui/material";
import {
    Sort as SortIcon
} from '@mui/icons-material';
import { OverridableComponent } from "@mui/material/OverridableComponent";

export const GlobalStyleTemplate = {
    span: {fontSize: "0.75rem"},
    p: {fontSize: "0.9rem !important"},
    h1: {colors: colors.cyan,},
    '.no-padding': {
        paddingLeft: '0 !important',
        paddingRight: '0 !important',
    },
};

export const FlippedSortIcon: OverridableComponent<SvgIconTypeMap<{}, 'svg'>> & { muiName: string } = Object.assign(
    (props: SvgIconProps) => (
        <SortIcon
            {...props}
            sx={{ transform: 'scaleX(-1) rotate(180deg)', ...props.sx }}
        />
    ),
    { muiName: SortIcon.muiName }
);
